'use strict';


app.factory('Menu', ['$http', 'env_config',
    function ($http, env_config) {
        var service = {};


        service.getDrinks = function (venue, callback) {

            $http.get(env_config.api_url + 'venues/' + venue.id + '/drinks?sending=true')
                .success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function (resp, status) {
                    callback(resp, status);
                });
        };


        return service;
    }]);